module.exports = __webpack_public_path__ + "assets/star-on-b07293.svg";